/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Upkeep_QuestionInputs */

const en_faq_upkeep_question = /** @type {(inputs: Faq_Upkeep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who looks after it once it’s live?`)
};

const lv_faq_upkeep_question = /** @type {(inputs: Faq_Upkeep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurš par to rūpējas, kad tā darbojas?`)
};

/**
* | output |
* | --- |
* | "Who looks after it once it’s live?" |
*
* @param {Faq_Upkeep_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_upkeep_question = /** @type {((inputs?: Faq_Upkeep_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Upkeep_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_upkeep_question(inputs)
	return en_faq_upkeep_question(inputs)
});